export const onDownloadStart=(message)=>{
    const url='http://54.93.73.56:8080/pub/download';
    console.log(message);
    const xhttp=new XMLHttpRequest();
    xhttp.open('POST', url, true);
    xhttp.setRequestHeader('Content-type', 'application/json; charset=utf8');
    xhttp.setRequestHeader( 'Access-Control-Allow-Origin', '*');
    xhttp.send(JSON.stringify(message));
};